import { CLOUD_SERVICE_BASE_URL } from "@/utils/const";
import axios from "axios";
import { getServiceConfigHeaders } from "@/utils/requestConfig";

// Helper function for API calls
async function apiCall(url, params = {}) {
  const config = await getServiceConfigHeaders();
  const baseUrl = CLOUD_SERVICE_BASE_URL + (process.env.VUE_APP_ENV === "production"
    ? "/portal/trans-service"
    : "/portal/trans-service-st"
  );

  return axios.get(baseUrl + url, {
    params,
    headers: config
  });
}

export function getUserInfoV2Api() {
  return apiCall("/utility/getUserInfoV2");
}

export function getSettingApi() {
  return apiCall("/utility/getSetting");
}

export function getCustomerInfoApi(params) {
  return apiCall("/utility/getCustomerInfo", params);
}

// Resolves patient_id / sample_id from an accession id, which is all a credit
// transaction row carries. Endpoint name is misspelled server-side.
export function listSampleMinimumInfoApi(accessionId) {
  return apiCall("/utility/listSampleMininumInfo", {
    accession_ids: `[${accessionId}]`,
  });
}

export function checkDuplicatedEmail(params) {
  return apiCall("/utility/checkDuplicatedEmail", params);
}
